import { connectionReducer } from './services/controller-connection.service';
import { commonConfigReducer } from './services/common-config.service';
import { ISubStore } from './interfaces/store';
import { backupReducer } from './services/backup.service';
import { directorConnectionReducer } from './director-connection/director-connection.service';
import { monitoredHttpReducer } from './services/monitored-http.service';
import { routerHistoryReducer } from './services/router-history.service';

export const CORE_STORE: ISubStore = {
  controllerConnection: connectionReducer,
  commonConfig: commonConfigReducer,
  backup: backupReducer,
  directorConnection: directorConnectionReducer,
  monitoredHttpState: monitoredHttpReducer,
  routerHistory: routerHistoryReducer
}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/core.store.ts